import { getAppNameFromUrl } from 'growth-payments-core/urls/utils';
import { Screen, Subscreen } from '../../../types/screen';
export const SupportedApps = {
  BLOG: 'blog',
  EMAIL: 'email',
  MEETINGS: 'meetings',
  PAGES: 'pages'
};
export const getAppInfo = () => {
  const appName = getAppNameFromUrl(window.location.href);
  const supportedAppName = appName && Object.values(SupportedApps).includes(appName) ? appName : 'unknown';
  switch (supportedAppName) {
    case SupportedApps.BLOG:
      return {
        appName: supportedAppName,
        screen: Screen.CMS,
        subscreen: Subscreen.CMS_BLOG
      };
    case SupportedApps.EMAIL:
      return {
        appName: supportedAppName,
        screen: Screen.EMAIL
      };
    case SupportedApps.MEETINGS:
      return {
        appName: supportedAppName,
        screen: Screen.MEETINGS
      };
    case SupportedApps.PAGES:
      return {
        appName: supportedAppName,
        screen: Screen.CMS,
        subscreen: Subscreen.CMS_PAGES
      };
    default:
      return {
        appName: supportedAppName,
        screen: Screen.UNKNOWN
      };
  }
};